import React, { useState } from 'react';
import PrayerCommentBox from './PrayerCommentBox';
import { Button, makeStyles, tokens, MessageBar } from '@fluentui/react-components';
import { testPrayerCommentsIntegration } from '../services/sharePointService';

const useStyles = makeStyles({
  container: {
    padding: '20px',
    maxWidth: '800px',
    margin: '0 auto',
  },
  header: {
    marginBottom: '20px',
  },
  testSection: {
    marginBottom: '20px',
    padding: '16px',
    border: `1px solid ${tokens.colorNeutralStroke1}`,
    borderRadius: '8px',
    backgroundColor: tokens.colorNeutralBackground1,
  },
  button: {
    marginRight: '8px',
  },
});

const PrayerCommentBoxDemo: React.FC = () => {
  const styles = useStyles();
  const [testResult, setTestResult] = useState<string | null>(null);
  const [isTesting, setIsTesting] = useState(false);

  const runTest = async () => {
    setIsTesting(true);
    setTestResult(null);
    
    try {
      await testPrayerCommentsIntegration();
      setTestResult('✅ Prayer comments integration test completed successfully!');
    } catch (error) {
      setTestResult(`❌ Test failed: ${error}`);
    } finally {
      setIsTesting(false);
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h1>Prayer Comment Box Demo</h1>
        <p>This demonstrates the PrayerCommentBox component with mock data.</p>
      </div>
      
      <div className={styles.testSection}>
        <h3>Test Prayer Comments Integration</h3>
        <p>Click the button below to test the prayer comments functionality:</p>
        <Button 
          appearance="primary" 
          onClick={runTest}
          disabled={isTesting}
          className={styles.button}
        >
          {isTesting ? 'Testing...' : 'Run Integration Test'}
        </Button>
        
        {testResult && (
          <MessageBar intent={testResult.includes('✅') ? 'success' : 'error'} style={{ marginTop: '12px' }}>
            {testResult}
          </MessageBar>
        )}
      </div>
      
      <div>
        <h3>Prayer Comment Box</h3>
        <p>This component will attempt to fetch and display comments for prayer ID 123:</p>
        <PrayerCommentBox prayerId={123} />
      </div>
    </div>
  );
};

export default PrayerCommentBoxDemo; 